export const formatTime = (date: Date) => {
  return new Date(date).toLocaleTimeString("sv-SE", {
    hour: "numeric",
    minute: "numeric",
  });
};
